import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { H1 } from '@btc-snxt/ui';
import { useTabsContext } from 'components/Tabs/TabsContext';
import { StyledNotificationSettings } from './NotificationSettings.style';

const NotificationSettings: React.FC = () => {
  const { t } = useTranslation();

  const tabsContext = useTabsContext();

  useEffect(() => {
    tabsContext.setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <StyledNotificationSettings>
        <H1>{t('settings.notifications')}</H1>
      </StyledNotificationSettings>
    </>
  );
};

export default NotificationSettings;
